module.exports = __webpack_public_path__ + "media/assets/images/logo-nexa-1391efe7b7b100574060e47bfcff7bed.svg";